import { useState } from 'react';
import { FACEBOOK_INTEGRATIONS_DELETE_URL } from 'api/FacebookIntegrationsAPI';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

type FacebookIntegrationRequest = {
  id: number;
};

export const useDeleteFacebookIntegration = () => {
  const [id, targetId] = useState<number | null>(null);
  const { mutate, isLoading, isSuccess, isError } = useRestMutation<
    unknown,
    FacebookIntegrationRequest
  >(FACEBOOK_INTEGRATIONS_DELETE_URL);
  const unsubscribe = (deletedId: number) => mutate({ id: deletedId });

  return {
    id,
    targetId,
    unsubscribe,
    isLoading,
    isSuccess,
    isError,
  };
};
